import Model from '@/models/Model'

export default class GErrorModel extends Model {

  /**
   * 
   */
  getError() {
    return this.getProperty('response.data.error', '')
  }

  /**
   * GError endpoint.
   */
  resource() {
    return 'g_error'
  }
}